import { Container } from "react-bootstrap";
import { People, CreditCard, CurrencyDollar } from "react-bootstrap-icons";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";
import { PageTitle } from "../../Controls/PageTitle";
import { Operator } from "../../Data/ApiTypes";
import { CollapsibleSidebar } from "../../Controls/CollapsibleSidebar";
import { CollapsibleMenuItem } from "../../Controls/CollapsibleMenuItem";

export function AppAdmin() {
    const loc      = useLocation();
    const operator = useLoaderData() as Operator;

    //for handling mobile and desktop versions of these pages
    const isAdminRoot = loc.pathname === `/admin`;
    const [menuClassName, contentClassName] = isAdminRoot ? ["", "d-none"] : ["d-none", ""];
    const activeOverride = loc.pathname === `/admin` || loc.pathname === `/admin/operators`;

    return <Container fluid className="fullheight pt-2">
        <div className="d-flex fullheight">
            <CollapsibleSidebar 
                className={menuClassName}
                header={
                    <PageTitle className="fw-bold text-center">
                        SpotSync Admin
                    </PageTitle>
                }
            >
                <CollapsibleMenuItem active={activeOverride} default icon={<People      />} to="./operators" text="Operators"/>                
                <CollapsibleMenuItem icon={<CreditCard  />} to="./fees" text="Fees" />
                <CollapsibleMenuItem default icon={<People      />} to="./users" text="Super Admins"/>
                <CollapsibleMenuItem icon={<CurrencyDollar />} to="./revenue" text="Revenue Report"/>
            </CollapsibleSidebar>
            <div className={`${contentClassName} p-0 m-0 d-md-block fullheight scroll-y-auto flex-fill`}>
                <Outlet />
            </div>
        </div>
    </Container>;
}